export default __webpack_public_path__ + "static/media/testing-arrow-desktop.7c5a73e4.svg";